/* Ace Air Direct sale components. Level Up Marketing Co. */
(function () {
  'use strict';

  // Current wall-clock time in America/New_York as a local Date object.
  function nyNow() {
    var p = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date());
    var g = function (t) { for (var i = 0; i < p.length; i++) if (p[i].type === t) return +p[i].value; return 0; };
    return new Date(g('year'), g('month') - 1, g('day'), g('hour') % 24, g('minute'), g('second'));
  }
  function isBiz(d) { var w = d.getDay(); return w > 0 && w < 6; }
  function nextBiz(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!isBiz(x)); return x; }
  function pad(n) { return String(n).padStart(2, '0'); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- hero slider ----- */
  function initSlider(root) {
    if (root.__aad) return; root.__aad = true;
    var track = root.querySelector('.aad-hero__track');
    var slides = root.querySelectorAll('.aad-hero__slide');
    var dots = root.querySelectorAll('.aad-hero__dots button');
    var n = slides.length, cur = 0, timer = null;
    var interval = (+root.getAttribute('data-interval') || 6) * 1000;
    if (!track || n < 2) return;
    function go(i) {
      cur = (i + n) % n;
      track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      for (var k = 0; k < n; k++) {
        slides[k].setAttribute('aria-hidden', k === cur ? 'false' : 'true');
        var links = slides[k].querySelectorAll('a');
        for (var j = 0; j < links.length; j++) { if (k === cur) links[j].removeAttribute('tabindex'); else links[j].setAttribute('tabindex', '-1'); }
        if (dots[k]) dots[k].setAttribute('aria-current', k === cur ? 'true' : 'false');
      }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (!reduceMotion && interval > 0) timer = setInterval(function () { go(cur + 1); }, interval); }
    var prev = root.querySelector('.aad-hero__arrow--prev'), next = root.querySelector('.aad-hero__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); start(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); start(); });
    for (var d = 0; d < dots.length; d++) (function (i) { dots[i].addEventListener('click', function () { go(i); start(); }); })(d);
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    // swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); start();
    });
    root.__aadGo = go;
    go(0); start();
  }

  /* ----- rolling countdown (repeats every N days from an anchor date, ET midnight) ----- */
  function tickCountdown(el) {
    var anchor = (el.getAttribute('data-anchor') || '').split('-');
    var days = +el.getAttribute('data-days') || 10;
    var now = nyNow();
    var a = anchor.length === 3 ? new Date(+anchor[0], +anchor[1] - 1, +anchor[2]) : new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var cycle = days * 864e5;
    var elapsed = now - a;
    var left = elapsed >= 0 ? cycle - (elapsed % cycle) : -elapsed;
    var s = Math.floor(left / 1000);
    var set = function (sel, v) { var t = el.querySelector(sel); if (t) t.textContent = pad(v); };
    set('[data-d]', Math.floor(s / 86400)); set('[data-h]', Math.floor(s % 86400 / 3600));
    set('[data-m]', Math.floor(s % 3600 / 60)); set('[data-s]', s % 60);
  }

  /* ----- noon shipping clock ----- */
  function tickShip(el) {
    var cutoff = +el.getAttribute('data-cutoff') || 12;
    var before = el.getAttribute('data-before') || 'Order in {time} for same-day shipping';
    var after = el.getAttribute('data-after') || 'Order now, ships {day}';
    var now = nyNow(), cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
    var out;
    if (isBiz(now) && now < cut) {
      var ms = cut - now, h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
      out = before.replace('{time}', '<span class="aad-ship__clock">' + (h ? h + 'h ' : '') + pad(m) + 'm ' + pad(s) + 's</span>');
    } else {
      var day = nextBiz(now).toLocaleDateString('en-US', { weekday: 'long' });
      out = after.replace('{day}', '<span class="aad-ship__clock">' + day + '</span>');
    }
    el.innerHTML = out;
  }

  /* ----- per-card ship / delivery estimate ----- */
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; }
  function etaText(cutoff) {
    var now = nyNow(), cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
    var same = isBiz(now) && now < cut, sd = same ? now : nextBiz(now);
    var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    var head = same ? 'Ships today if ordered by noon' : 'Ships ' + sd.toLocaleDateString('en-US', { weekday: 'long' });
    return '&#128666; ' + head + '<small>Arrives ' + f(addBiz(sd, 1)) + ' - ' + f(addBiz(sd, 4)) + '</small>';
  }
  function tickEta() {
    var e = document.querySelectorAll('[data-aad-eta]'); if (!e.length) return;
    var html = etaText(+e[0].getAttribute('data-aad-eta') || 12);
    for (var i = 0; i < e.length; i++) if (e[i].innerHTML !== html) e[i].innerHTML = html;
  }

  /* ----- phone open / closed status (Mon-Fri, hours ET) ----- */
  function tickOpen(el) {
    var open = +el.getAttribute('data-open') || 9, close = +el.getAttribute('data-close') || 17;
    var n = nyNow(), h = n.getHours() + n.getMinutes() / 60, isOpen = isBiz(n) && h >= open && h < close, txt;
    if (isOpen) { var m = Math.round((close - h) * 60); txt = m <= 60 ? 'Open now, closes in ' + m + ' min' : "Open now, we're answering calls"; }
    else { var today = isBiz(n) && h < open, back = today ? n : nextBiz(n); txt = 'Closed now, back ' + (today ? 'today' : back.toLocaleDateString('en-US', { weekday: 'long' })) + ' at ' + (open > 12 ? open - 12 + 'pm' : open + 'am') + ' ET'; }
    el.textContent = txt; el.classList.toggle('is-closed', !isOpen);
  }

  /* ----- tabs ----- */
  function initTabs(root) {
    if (root.__aad) return; root.__aad = true;
    var btns = root.querySelectorAll('[data-tab-btn]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    function show(i) {
      for (var k = 0; k < btns.length; k++) btns[k].setAttribute('aria-selected', String(k === i));
      for (var j = 0; j < panels.length; j++) { if (j === i) panels[j].removeAttribute('hidden'); else panels[j].setAttribute('hidden', ''); }
    }
    for (var b = 0; b < btns.length; b++) (function (i) { btns[i].addEventListener('click', function () { show(i); }); })(b);
    show(0);
  }

  function init(scope) {
    scope = scope || document;
    var s = scope.querySelectorAll('[data-aad-slider]'); for (var i = 0; i < s.length; i++) initSlider(s[i]);
    var t = scope.querySelectorAll('[data-aad-tabs]'); for (var j = 0; j < t.length; j++) initTabs(t[j]);
    if (scope.querySelector('.aad-mbar')) document.body.classList.add('aad-has-mbar');
  }
  function tickAll() {
    var c = document.querySelectorAll('[data-aad-countdown]'); for (var i = 0; i < c.length; i++) tickCountdown(c[i]);
    var s = document.querySelectorAll('[data-aad-ship]'); for (var j = 0; j < s.length; j++) tickShip(s[j]);
    var o = document.querySelectorAll('[data-aad-open]'); for (var k = 0; k < o.length; k++) tickOpen(o[k]);
    tickEta();
  }

  if (!window.__aadSaleLoaded) {
    window.__aadSaleLoaded = true;
    var boot = function () { init(document); tickAll(); setInterval(tickAll, 1000); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); tickAll(); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('.aad-hero__slide');
      var root = slide && slide.closest('[data-aad-slider]');
      if (root && root.__aadGo) { var all = root.querySelectorAll('.aad-hero__slide'); for (var i = 0; i < all.length; i++) if (all[i] === slide) root.__aadGo(i); }
    });
  }
})();
